"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useJira_1 = __importDefault(require("hooks/useJira"));
const ContentJira_1 = __importDefault(require("./ContentJira"));
const FooterModalJira_1 = __importDefault(require("./FooterModalJira"));
const HeaderModalJira_1 = __importDefault(require("./HeaderModalJira"));
const ContentModalJira = ({ closeCurrentModal, objectiveId, objectiveChildrenCount, currentIntegration, setObjectiveValue, modalType, changeValue }) => {
    const stepModal = (0, useJira_1.default)((state) => state.stepModal);
    const setStepModal = (0, useJira_1.default)((state) => state.setStepModal);
    const setSelectedJIRA = (0, useJira_1.default)((state) => state.setSelectedJIRA);
    const setSelectedData = (0, useJira_1.default)((state) => state.setSelectedData);
    const setImportChild = (0, useJira_1.default)((state) => state.setImportChild);
    const selectedData = (0, useJira_1.default)((state) => state.selectedData);
    const initialValueJira = (0, useJira_1.default)((state) => state.initialValueJira);
    const setAdditionalParams = (0, useJira_1.default)((state) => state.setAdditionalParams);
    const isViewChildOnCreate = (0, react_1.useMemo)(() => stepModal == 'child-issues' && modalType != 'import-child', [stepModal, modalType]);
    const buttonTextModal = (0, react_1.useMemo)(() => modalType == 'import-child'
        ? 'Import Issue'
        : stepModal == 'choose-data'
            ? 'Next'
            : 'Link Project', [modalType, stepModal]);
    const resetData = () => {
        setImportChild(false);
        setStepModal('choose-data');
        setSelectedData('');
        setSelectedJIRA({});
        setAdditionalParams({});
    };
    (0, react_1.useEffect)(() => {
        stepModal !== 'child-issues' && setSelectedJIRA(initialValueJira);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedData]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        setImportChild(false);
        setStepModal(modalType == 'import-child' ? 'child-issues' : 'choose-data');
        setSelectedData(modalType == 'import-child' ? 'issue' : 'project');
        setSelectedJIRA(currentIntegration);
        modalType == 'import-child' &&
            setAdditionalParams((currentIntegration === null || currentIntegration === void 0 ? void 0 : currentIntegration.integrationType) == 'project'
                ? { project: (_a = currentIntegration === null || currentIntegration === void 0 ? void 0 : currentIntegration.data) === null || _a === void 0 ? void 0 : _a.key }
                : { parent: (_b = currentIntegration === null || currentIntegration === void 0 ? void 0 : currentIntegration.data) === null || _b === void 0 ? void 0 : _b.key });
        return () => {
            resetData();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(() => {
        stepModal == 'child-issues' && setSelectedData('issue');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stepModal]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HeaderModalJira_1.default, { closeCurrentModal: closeCurrentModal, isViewChildOnCreate: isViewChildOnCreate }),
        react_1.default.createElement(ContentJira_1.default, { objectiveChildrenCount: objectiveChildrenCount, modalType: modalType }),
        react_1.default.createElement(FooterModalJira_1.default, { primaryTitleButton: buttonTextModal, closeCurrentModal: closeCurrentModal, currentIntegration: currentIntegration, isViewChildOnCreate: isViewChildOnCreate, modalType: modalType, setObjectiveValue: setObjectiveValue, changeValue: changeValue, objectiveId: objectiveId })));
};
exports.default = ContentModalJira;
